import {Button, Card, Carousel, Col, Form, Input, message, Modal, Radio, Row, Space, Spin, Typography} from 'antd';
import {DashboardWrapperDto} from "../../dto/DashboardWrapperDto";
import '../../pages/customerDashboard/styles.scss';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faObjectGroup, faUser} from "@fortawesome/free-solid-svg-icons";
import {useRef, useState} from "react";
import {AccountCardDetailDto} from "../../dto/AccountCardDetailDto";
import {faUserGroup} from "@fortawesome/free-solid-svg-icons/faUserGroup";
import CommonFunction from "../../util/CommonFunction";
import {
    CloseOutlined,
    EditOutlined,
    ExclamationCircleOutlined,
    SwapOutlined,
    UsergroupAddOutlined
} from "@ant-design/icons";
import {
    COMMON_DROPDOWN,
    EMAIL_MAX_LENGTH,
    EMAIL_VALIDATION,
    IDENTIFICATION_SOURCE,
    MOBILE_NUMBER_MAX_LENGTH,
    MOBILE_NUMBER_MIN_LENGTH,
    NIC_VALIDATION,
    PARAMETER_LIST
} from "../../util/Constants";
import {
    MSG_FAILED_TO_FETCH_IDENTIFICATION_SOURCE_TYPES_ERROR,
    MSG_FAILED_TO_FETCH_SECOND_APPLICANT_DETAILS_ERROR,
    MSG_FAILED_TO_UPDATE_SECOND_APPLICANT_ERROR,
    MSG_JOINT_ACCOUNT_CANCELED_ERROR,
    MSG_JOINT_ACCOUNT_CANCELED_SUCCESS,
    MSG_JOINT_ACCOUNT_CONVERT_ERROR,
    MSG_JOINT_ACCOUNT_CONVERT_SUCCESS,
    MSG_NO_CHANGES_TO_UPDATE,
    MSG_PLEASE_ENTER_A_VALID_EMAIL,
    MSG_SECOND_APPLICANT_UPDATED_SUCCESS
} from "../../util/Messages";
import Validation from "../../util/Validation";
import {DropdownListDto} from "../../dto/DropdownListDto";
import {SecondApplicantDetailDto} from "../../dto/SecondApplicantDetailDto";
import accountService from "../../service/accountService";
import ErrorHandler from "../../util/ErrorHandler";
import customerService from "../../service/customerService";
import {CustomerDto} from "../../dto/CustomerDto";
import {toLower} from "lodash";
import {InputDropdownParameterDto} from "../../dto/InputDropdownParameterDto";
import modal from "antd/es/modal";
import {xappHomeLogo} from "../../../AppImageConst";

const {Paragraph} = Typography;

interface PropTypes {
    accountDetails: DashboardWrapperDto
    updateComp: (portfolioId: number) => void
    onEdit: () => void
}

const JOINT_ACCOUNT = "Joint Account"
const COMBINE_VIEW = "COMBINE_VIEW"

const AccountCardCarousal = (props: PropTypes) => {

    const [isCustomerExisting, setCustomerIsExisting] = useState(false);
    const [isModalLoading, setModalLoading] = useState(false);
    const [isUpdateDisable, setUpdateDisable] = useState(false);
    const [dropdownDto, setDropdownDto] = useState<DropdownListDto | undefined>({label: "NIC", value: 1});
    const [identificationSourceTypeList, setIdentificationSourceTypeList] = useState<DropdownListDto[]>([]);
    let [secondApplicatDetailDto, setSecondApplicatDetailDto] = useState<SecondApplicantDetailDto>();
    const [form] = Form.useForm();
    const carouselRef = useRef(null);

    const loadIdentitySourceTypes = () => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.IDENTIFICATION_SOURCE,
            findTextValue: "",
            parameterList: [PARAMETER_LIST.ACTIVE]
        }
        customerService.getCommonDropdown(inputDropdownParameterDto).then(res => {
            if (res.data !== null) {
                setIdentificationSourceTypeList(res.data.results.activeItemList)
            } else {
                message.error(MSG_FAILED_TO_FETCH_IDENTIFICATION_SOURCE_TYPES_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }

    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = (reference: string) => {
        setModalLoading(true)
        loadSecondApplicantDetails(reference);
    };

    const resetFields = () => {
        form.resetFields(["cidNumber", "mobileNumber", "email", "name", "identificationSourceId",
            "identificationSourceValue"])
    }
    const loadSecondApplicantDetails = (reference: string) => {
        accountService.getSecondApplicantForUpdate(reference).then(res => {
            if (res.data !== null) {
                const secondApplicantDetails = res.data.results as SecondApplicantDetailDto
                if (secondApplicantDetails.isExistingCustomer) {
                    setUpdateDisable(true)
                }
                setSecondApplicantModalFormData(secondApplicantDetails)
                setSecondApplicatDetailDto(secondApplicantDetails)
                loadIdentitySourceTypes();
                setIsModalOpen(true);
                setModalLoading(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_SECOND_APPLICANT_DETAILS_ERROR).then();
                setModalLoading(false)
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setModalLoading(false)
        })
    }

    const setSecondApplicantModalFormData = (data: SecondApplicantDetailDto) => {
        setFormValues(data)
        setCustomerIsExisting(data.isExistingCustomer)
    }

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onchangeIsExistingCustomer = (e: Event) => {
        const value = (e.target as HTMLInputElement).value as unknown as boolean;
        setCustomerIsExisting(value)
        if (secondApplicatDetailDto?.isExistingCustomer) {
            if (!value) {
                resetFields()
                setDropdownDto({label: "NIC", value: 1})
                setUpdateDisable(false)
            } else {
                setUpdateDisable(true)
                setFormValues(secondApplicatDetailDto as SecondApplicantDetailDto)
            }
        } else {
            if (value) {
                resetFields()
                setDropdownDto({label: "NIC", value: 1})
                setUpdateDisable(true)
            } else {
                setUpdateDisable(false)
                setFormValues(secondApplicatDetailDto as SecondApplicantDetailDto)
            }
        }
    }

    const setFormValues = (data: SecondApplicantDetailDto) => {
        form.setFieldsValue(
            {
                cidNumber: data.cidNumber,
                isExistingCustomer: data.isExistingCustomer,
                mobileNumber: data.mobileNumber,
                email: data.email,
                name: data.name,
                identificationSourceId: data.identificationSourceId,
                identificationSourceValue: data.identificationSourceValue
            }
        )
        let dropdownListDto = identificationSourceTypeList.find((obj: DropdownListDto) => {
            return obj.value == data.identificationSourceId
        });
        setDropdownDto(dropdownListDto)
    }

    const onChangeSourceType = (e: Event) => {
        let dropdownListDto = identificationSourceTypeList.find((obj: DropdownListDto) => {
            return obj.value == (e.target as HTMLInputElement).value
        });
        setDropdownDto(dropdownListDto)
        form.resetFields(['identificationSourceValue'])
    };

    const handleCINEnter = (val: string) => {
        if (val !== "") {
            setModalLoading(true)
            customerService.getCustomerDateByCin(val).then(res => {
                if (res.data.results.customerMstDto != null) {
                    const customerDto = res.data.results.customerMstDto as CustomerDto
                    form.setFieldsValue(
                        {
                            mobileNumber: customerDto.mobileNo,
                            email: customerDto.email,
                            name: customerDto.nameToAppearOnStatement,
                            identificationSourceId: customerDto.identificationSource?.id,
                            identificationSourceValue: customerDto.identificationValue
                        }
                    )
                    let dropdownListDto = identificationSourceTypeList.find((obj: DropdownListDto) => {
                        return obj.value == customerDto.identificationSource?.id
                    });
                    setDropdownDto(dropdownListDto)
                    setModalLoading(false)
                    setUpdateDisable(false)
                }

            }, (reason) => {
                setModalLoading(false)
                setUpdateDisable(true)
                ErrorHandler.handleError(reason);
                // resetFields()
            })
        }

    }
    const clearForm = () => {
        setUpdateDisable(true)
        form.resetFields(['mobileNumber', 'identificationSourceValue', 'identificationSourceId', 'name', 'email'])
        setDropdownDto({label: "NIC", value: 1})
    }

    const getPlaceHolderByIdentificationType = (identificationType: string | undefined) => {
        if (undefined != identificationType) {
            return IDENTIFICATION_SOURCE.NIC === identificationType ? identificationType : toLower(identificationType)
        }
        return "N/A"
    }

    const updateSecondApplicant = (values: SecondApplicantDetailDto) => {

        let secondApplicant: SecondApplicantDetailDto = values;

        if (checkForChanges(secondApplicatDetailDto as SecondApplicantDetailDto, secondApplicant)) {
            setModalLoading(true)
            secondApplicant.id = secondApplicatDetailDto?.id as number
            accountService.updateSecondApplicantDetails(secondApplicant).then(res => {
                if (res.data !== null) {

                    message.success(MSG_SECOND_APPLICANT_UPDATED_SUCCESS)
                    // selectFirstSlide()
                    props.onEdit()
                    setModalLoading(false)
                    setIsModalOpen(false)
                } else {
                    message.error(MSG_FAILED_TO_UPDATE_SECOND_APPLICANT_ERROR).then();
                    setModalLoading(false)
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                setModalLoading(false)
            })
        } else {
            message.warning(MSG_NO_CHANGES_TO_UPDATE)
        }
    }

    const checkForChanges = (oldValues: SecondApplicantDetailDto, newValues: SecondApplicantDetailDto) => {
        if (oldValues.isExistingCustomer != newValues.isExistingCustomer) {
            return true;
        } else if (oldValues.cidNumber != newValues.cidNumber) {
            return true;
        } else if (oldValues.name != newValues.name) {
            return true;
        } else if (oldValues.email != newValues.email) {
            return true;
        } else if (oldValues.mobileNumber != newValues.mobileNumber) {
            return true;
        } else if (oldValues.identificationSourceId != newValues.identificationSourceId) {
            return true;
        } else if (oldValues.identificationSourceValue != newValues.identificationSourceValue) {
            return true;
        }
        return false;
    }

    // const selectFirstSlide = () => {
    //     if (carouselRef.current) {
    //         carouselRef.current?.goTo(0);
    //     }
    // };
    //
    // const handleClickPrev = () => {
    //     if (carouselRef.current) {
    //         carouselRef.current.prev();
    //     }
    // };
    //
    // const handleClickNext = () => {
    //     if (carouselRef.current) {
    //         carouselRef.current.next();
    //     }
    // };
    // const handleAfterChange = (index: number) => {
    //     props.updateComp(props.accountDetails.accountCardDetails[index].accountNumber)
    // }


    const cancelJointAccount = (reference: string) => {
        modal.confirm({
            title: 'Confirm',
            icon: <ExclamationCircleOutlined/>,
            content: `Are you sure?, Do you want to cancel this joint account?`,
            okText: 'Yes',
            cancelText: 'No',
            className: 'confirm-dialog-box',
            okButtonProps: {style: {background: '#FF7400'}},
            onOk() {
                setModalLoading(true)
                accountService.cancelJointAccount(reference).then(res => {
                    if (res.data !== null) {
                        message.success(MSG_JOINT_ACCOUNT_CANCELED_SUCCESS)
                        props.onEdit()
                        setModalLoading(false)
                    } else {
                        message.error(MSG_JOINT_ACCOUNT_CANCELED_ERROR).then();
                        setModalLoading(false)
                    }
                }, (reason) => {
                    ErrorHandler.handleError(reason);
                    setModalLoading(false)
                })
            },
            onCancel() {

            }
        });

    }

    const convertJointAccountIntoIndividualAccount = (reference: string) => {
        modal.confirm({
            title: 'Confirm',
            icon: <ExclamationCircleOutlined/>,
            content: `Are you sure?, Do you want to convert this joint account into an individual account?`,
            okText: 'Yes',
            cancelText: 'No',
            className: 'confirm-dialog-box',
            okButtonProps: {style: {background: '#FF7400'}},
            onOk() {
                setModalLoading(true)
                accountService.convertJointAccountIntoIndividualAccount(reference).then(res => {
                    if (res.data !== null) {
                        message.success(MSG_JOINT_ACCOUNT_CONVERT_SUCCESS)
                        props.onEdit()
                        setModalLoading(false)
                    } else {
                        message.error(MSG_JOINT_ACCOUNT_CONVERT_ERROR).then();
                        setModalLoading(false)
                    }
                }, (reason) => {
                    ErrorHandler.handleError(reason);
                    setModalLoading(false)
                })
            },
            onCancel() {

            }
        });

    }

    return (
        <>
            <Spin spinning={isModalLoading} size="large">
                <Card size={'small'} className='main-card-bg-none'>
                    <Carousel ref={carouselRef} fade={true} className='portfolio-card-carousel'>

                        {props.accountDetails.accountCardDetails.map((data: AccountCardDetailDto) => {
                            let isJointAccount = JOINT_ACCOUNT == data.accountType;
                            let isCombineView = COMBINE_VIEW == data.accountType;

                            return (
                                !isCombineView ?
                                <div>
                                    <Card className={isJointAccount ? 'portfolio-card joint-card' : 'portfolio-card individual-card'}>
                                        <div className="portfolio-card-layout">
                                            <div className="portfolio-content-area" style={{height: 200}}>
                                                <div>
                                                    <div className="account-type">
                                                        <div className={'acc-type-left-side'}>
                                                            <div className="account-type-icon">

                                                                <FontAwesomeIcon
                                                                    icon={isJointAccount ? faUserGroup : faUser}/>
                                                            </div>
                                                            <div className={'account-type-div'}>
                                                                <span
                                                                    className='account-type-span'>{data.accountName} </span>
                                                                {null != data.accountNumber ?
                                                                    <Paragraph className='account-portfolio-span'
                                                                               copyable>{data.accountNumber}</Paragraph>
                                                                    : <Paragraph
                                                                        className='account-portfolio-span'>Pending</Paragraph>}

                                                            </div>
                                                        </div>
                                                        <div className='acc-type-right-side'>
                                                            <img src={xappHomeLogo} alt="logo"
                                                                 className='ndb-logo'/>
                                                            <span
                                                                className={data.accountType === 'Joint Account' ? 'account-type-span joint-acc-span' : 'account-type-span ind-acc-span'}>{data.accountType}</span>
                                                        </div>
                                                    </div>

                                                    <div className="your-wealth-info">
                                                                <span className='your-wealth-info-span'>
                                                                    Your Wealth
                                                                </span>
                                                        <span className='your-wealth-value-info-span'>
                                                                    <span className="wealth-LKR">LKR</span>
                                                                    <span>{CommonFunction.decimalFormat(data.accountBalance)}</span>
                                                                </span>
                                                    </div>
                                                </div>


                                                <div className="last-row-info">
                                                    <div className="created-date-info">
                                                                    <span className="open-date-lbl-span">
                                                                        Opened Date
                                                                    </span>
                                                        <span
                                                            className="open-date-span">{null != data.accountRequestDate ? data.accountRequestDate : "Pending"}</span>
                                                    </div>

                                                    {isJointAccount ?
                                                        <div className="second-holder-info">
                                                            {null != data.secondApplicantName ?
                                                                <>
                                                                    <span className="second-holder-span">
                                                                        Secondary Holder
                                                                    </span>
                                                                    <span
                                                                        className="second-holder-value-span">{CommonFunction.validateText(data.secondApplicantName)}</span>
                                                                </>

                                                                :
                                                                <>
                                                                    <span className="second-holder-span">
                                                                        Primary Holder
                                                                    </span>
                                                                    <span
                                                                        className="second-holder-value-span">{CommonFunction.validateText(data.primaryApplicantName)}</span>
                                                                </>}
                                                        </div> :
                                                        <div className="second-holder-info">
                                                            <>
                                                                    <span className="second-holder-span">
                                                                        Nickname
                                                                    </span>
                                                                <span
                                                                    className="second-holder-value-span">{CommonFunction.validateText(data.nickName)}</span>
                                                            </>


                                                        </div>}
                                                </div>

                                            </div>

                                        </div>
                                        <div className="edit-cancel-btns">
                                            {data.isSecondApplicantEditable ?
                                                <Button size={'small'} ghost className={'btn-edit'}
                                                        icon={<EditOutlined/>}
                                                        onClick={() => showModal(data.reference)}>Edit</Button> : <></>}
                                            {data.cancelPortfolio ?
                                                <Button size={'small'} ghost className={'btn-cancel'}
                                                        icon={<CloseOutlined/>}
                                                        onClick={() => cancelJointAccount(data.reference)}>Cancel</Button> : <></>}
                                            {data.convertPortfolio ?
                                                <Button size={'small'} ghost className={'btn-convert'}
                                                        icon={<SwapOutlined/>}
                                                        onClick={() => convertJointAccountIntoIndividualAccount(data.reference)}>Convert</Button> : <></>}
                                        </div>
                                    </Card>
                                </div> :
                                    <div>
                                        <Card
                                            className={'portfolio-card combine-view'}>
                                            <div className="portfolio-card-layout">
                                                <div className="portfolio-content-area" style={{height: 200}}>
                                                    <div>
                                                        <div className="account-type">
                                                            <div className={'acc-type-left-side'}>
                                                                <div className="account-type-icon">

                                                                    <FontAwesomeIcon
                                                                        icon={faObjectGroup}/>
                                                                </div>
                                                                <div className={'account-type-div'}>
                                                                <span
                                                                    className='account-type-span'>{data.accountName} </span>
                                                                </div>
                                                            </div>
                                                            <div className='acc-type-right-side'>
                                                                <img src={xappHomeLogo} alt="logo"
                                                                     className='ndb-logo'/>
                                                                <span
                                                                    className={'account-type-span ind-acc-span'}>Combine View</span>
                                                            </div>
                                                        </div>

                                                        <div className="your-wealth-info">
                                                                <span className='your-wealth-info-span'>
                                                                    Your Wealth
                                                                </span>
                                                            <span className='your-wealth-value-info-span'>
                                                                    <span className="wealth-LKR">LKR</span>
                                                                    <span>{CommonFunction.decimalFormat(data.accountBalance)}</span>
                                                                </span>
                                                        </div>
                                                    </div>


                                                </div>

                                            </div>
                                        </Card>
                                    </div>
                            )
                        })}

                    </Carousel>
                </Card>
            </Spin>
            <Modal
                title={
                    <div>
                        <div className='page-header-main-title-col'>
                            <h2 className='page-header-main-title' style={{fontSize: 22}}>
                                <div className='header_icon header-icon-center'>
                                    <UsergroupAddOutlined />
                                </div>
                                Edit Second Applicant Details
                            </h2>
                        </div>

                    </div>
                }
                open={isModalOpen} footer={[]} destroyOnClose={true} closable={false}>
                <Spin size="large" tip="Loading" spinning={isModalLoading}>
                    <Form
                        className='form-input'
                        layout={"vertical"}
                        form={form}
                        onFinish={updateSecondApplicant}
                    >
                        <Row gutter={[32, 0]}>

                            <Col xs={24} sm={24} md={24} lg={24} xl={24} className={'margin_top_20'}>
                                <Form.Item
                                    label="Is the second applicant an existing customer?"
                                    name={"isExistingCustomer"}
                                    rules={
                                        [{
                                            required: true,
                                            message: 'Please select whether the customer is existing'
                                        }]}>
                                    <Radio.Group optionType="button"
                                                 buttonStyle="solid"
                                                 getPopupContainer={(trigger: {
                                                     parentNode: any;
                                                 }) => trigger.parentNode}
                                                 onChange={onchangeIsExistingCustomer}
                                    >

                                        <Radio.Button value={true}>Yes</Radio.Button>
                                        <Radio.Button value={false}>No</Radio.Button>

                                    </Radio.Group>

                                </Form.Item>
                            </Col>

                            {
                                isCustomerExisting ?
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <Form.Item
                                            label="CIN"
                                            name={"cidNumber"}
                                            rules={[{required: true, message: 'Please enter CIN'}]}

                                        >
                                            <Input onBlur={(e: any) => handleCINEnter(e.target.value)}
                                                   onFocus={clearForm}
                                                   placeholder={"Enter CIN"}/>
                                        </Form.Item>
                                    </Col> : ''
                            }

                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item
                                    label="Name"
                                    name={"name"}
                                    rules={[{required: !isCustomerExisting, message: 'Please enter name'}]}>
                                    <Input placeholder={"Enter name"} disabled={isCustomerExisting}/>
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item
                                    label="Email"
                                    name={"email"}
                                    rules={
                                        [
                                            {required: !isCustomerExisting, message: 'Please enter your email'},
                                            {
                                                max: EMAIL_MAX_LENGTH,
                                                message: 'The maximum length is 254 characters'
                                            },
                                            {
                                                pattern: EMAIL_VALIDATION,
                                                message: MSG_PLEASE_ENTER_A_VALID_EMAIL
                                            },

                                        ]}>
                                    <Input disabled={isCustomerExisting}
                                           placeholder={"Enter name"}/>
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item
                                    label={"Mobile Number"}
                                    name="mobileNumber"
                                    onKeyPress={Validation.isNumberWithoutDot}
                                    rules={[{required: !isCustomerExisting, message: 'Please enter your mobile number'},
                                        {
                                            max: MOBILE_NUMBER_MAX_LENGTH,
                                            message: 'The maximum length is 15 numbers'
                                        },
                                        {
                                            min: MOBILE_NUMBER_MIN_LENGTH,
                                            message: 'Minimum of 7 characters are required'
                                        },
                                    ]}>
                                    <Input disabled={isCustomerExisting}
                                           placeholder="Enter mobile number"/>
                                </Form.Item>

                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item
                                    label="Identification Source"
                                    name={"identificationSourceId"}
                                    initialValue={1}
                                    rules={[
                                        {required: !isCustomerExisting, message: 'Please select identification source'},
                                    ]}>


                                    <Radio.Group onChange={onChangeSourceType} disabled={isCustomerExisting}
                                                 defaultValue={dropdownDto?.value}>
                                        {identificationSourceTypeList.map((data: DropdownListDto) => {
                                            return <Radio value={data.value}>{data.label}</Radio>
                                        })}
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item
                                    label={dropdownDto?.label.concat(" Number")}
                                    name="identificationSourceValue"
                                    onKeyPress={(dropdownDto?.label === IDENTIFICATION_SOURCE.NIC) ? Validation.nicFieldValidation : Validation.isNumbersAndLetters}
                                    rules={[
                                        {
                                            required: !isCustomerExisting,
                                            message: 'Please enter your '.concat(getPlaceHolderByIdentificationType(dropdownDto?.label)).concat(" number")
                                        },
                                        (dropdownDto?.label !== IDENTIFICATION_SOURCE.NIC) ? {
                                            max: 15,
                                            message: 'The maximum length is 15 characters'
                                        } : {},
                                        (dropdownDto?.label === IDENTIFICATION_SOURCE.NIC) ? {
                                            pattern: NIC_VALIDATION,
                                            message: "Please enter a valid NIC number"
                                        } : {},
                                    ]}>
                                    <Input disabled={isCustomerExisting}
                                           placeholder={"Enter your ".concat(getPlaceHolderByIdentificationType(dropdownDto?.label)).concat(" number")}/>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Space style={{float: 'right'}}>
                                    <Button onClick={handleCancel} className='cancel-btn'>
                                        Cancel
                                    </Button>
                                    <Button htmlType="submit" className='submit-btn' disabled={isUpdateDisable}
                                            type="primary">
                                        Update
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    </Form>
                </Spin>
            </Modal>
        </>
    );
};

export default AccountCardCarousal;
